import styled from "styled-components";
import Spring from "../../components/Spring";

export const StyledNotFound = styled(Spring)`
    min-height: calc(100vh - 50px);
    overflow: hidden;
    background-color: ${p => p.theme.c.white};
    text-align: center;
    padding: 0 0 0;
    display: flex;
    flex-direction: column;
`;
